import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import IconTile from '@alltrails/denali/components/IconTile';
import TableRow from '@alltrails/denali/components/TableRow';
import Location from '@alltrails/denali/icons/Location';
import styles from './styles/styles.module.scss';

const NearbyResultContent = () => {
  const icon = <IconTile icon={{ Component: Location }} />;

  return (
    <TableRow
      className={classNames(styles.listItemContent, styles.noDescription)}
      leftContent={icon}
      label={
        <div className={styles.label}>
          <FormattedMessage defaultMessage="Nearby" />
        </div>
      }
    />
  );
};

export default NearbyResultContent;
